import { jsxs, jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import { forwardRef } from 'react';
import { BreadCrumbElementTypes } from '../types/index.js';
import { useBreadCrumbStyles, useBreadCrumbSkinStyles } from '../styles/index.js';
import { computeResponsiveness } from '../../../../foundation/responsive/helpers/index.js';

const BreadCrumb = forwardRef(({ tag: Tag = BreadCrumbElementTypes.Button, startIcon: StartIcon, children, isActive, className, size, ...props }, ref) => {
    const sizes = computeResponsiveness(size);
    const layoutStyles = useBreadCrumbStyles({ tag: Tag, sizes });
    const skinStyles = useBreadCrumbSkinStyles();
    return (jsxs(Tag, { ref: ref, "data-testid": "breadcrumb", className: clsx(layoutStyles.root, {
            [layoutStyles.rootHasIcon]: StartIcon,
            [skinStyles.default]: !isActive,
            [skinStyles.active]: isActive,
        }, className), ...props, children: [StartIcon && (jsx(StartIcon, { className: layoutStyles.icon, "data-testid": "start-icon" })), children] }));
});
BreadCrumb.displayName = 'BreadCrumb';

export { BreadCrumb };
